<template>
  <Dialog header="Warning" v-model:visible="visible" :closable="false"
    :breakpoints="{ '960px': '40vw', '641px': '60vw', '500px': '80vw' }" :style="{ width: '30vw' }" :modal="true">
    <img class="success" src="../../assets/Gif/warning.gif
    " />
    <p class="msg mt-3">{{ warningmsgcontent.content }}</p>
    <template #header>
      <Button icon="pi pi-times d-flex d-flex-reverse" @click="$emit('Ok')" />
    </template>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, watch } from "vue";
export default defineComponent({
  props: {
    visible: {
      readonly: false,
      type: Boolean,
      default: ref(false),
      life: 1000,
    },
    content: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const warningmsgcontent = reactive({
      content: "",
    });

    watch(props, (newValue) => {
      debugger;
      warningmsgcontent.content = newValue.content;
    });
    return {
      warningmsgcontent,
    };
  },

  methods: {},
});
</script>
<style lang="scss" scoped>
.success {
  width: 100px;
}
</style>
